import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { Typography } from '@homeviews/shared-ui'
import { Link } from 'react-router-dom'
import type { ITheme } from '@homeviews/styles'
import Skeleton from '@material-ui/lab/Skeleton'
import type { IWidgetType } from './WidgetTypes'
import { WIDGET_TYPES } from './WidgetTypes'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    title: {
      color: theme.colors.grey800,
    },
  }),
)

export const headCells: any = [
  {
    id: 'widget_id',
    label: 'Widget ID',
  },
  {
    id: 'widget_name',
    label: 'Widget name',
    sortable: true,
  },
  {
    id: 'development',
    label: 'Development',
    sortable: true,
  },
  {
    id: 'widget_type',
    label: 'Widget Type',
    sortable: true,
  },
  {
    id: 'website',
    label: 'Publish URL',
  },
  {
    id: 'actions',
    label: 'Actions',
  },
]

interface IActionsCell {
  id: number
  handleDeleteWidget: WidgetActionType
}
const ActionsCell: FC<IActionsCell> = ({ id, handleDeleteWidget }) => {
  return (
    <div className="l-table__actionsCell">
      <Link
        className="l-table__link l-table__link--primary"
        to={`/widgets/${id}/preview`}
      >
        <span className="l-table__link l-table__link--primary">Preview</span>
      </Link>
      <span
        className="l-table__link l-table__link--delete"
        onClick={() => handleDeleteWidget(id)}
      >
        Delete
      </span>
    </div>
  )
}

type WidgetActionType = (id: number) => void

interface ITitleProps {
  name: string
}
const TitleWrapper: FC<ITitleProps> = ({ name }) => {
  const classes = useStyles()
  return <Typography className={classes.title}>{name}</Typography>
}

function createData(
  widget: any,
  handleGetWidget: WidgetActionType,
  handleDeleteWidget: WidgetActionType,
) {
  const { id, title, development, widget_type, website } = widget
  return [
    <React.Fragment key="id1">{id}</React.Fragment>,
    <React.Fragment key="id2">{id}</React.Fragment>,
    <TitleWrapper key="title" name={title} />,
    <React.Fragment key="dev">{development?.name || ''}</React.Fragment>,
    <React.Fragment key="type">
      {WIDGET_TYPES.find((x: IWidgetType) => x.id === widget_type)?.title || ''}
    </React.Fragment>,
    <React.Fragment key="url">{website}</React.Fragment>,
    <ActionsCell
      key="actions"
      id={id}
      handleDeleteWidget={handleDeleteWidget}
    />,
  ]
}

export const createRows = (
  data: any[],
  handleGetWidget: WidgetActionType,
  handleDeleteWidget: WidgetActionType,
) => {
  if (!data?.length) {
    return []
  }

  return data.map((widget: any) =>
    createData(widget, handleGetWidget, handleDeleteWidget),
  )
}

export const createSkeletonRows = () =>
  Array(10)
    .fill('0')
    .map((_, idx) =>
      Array(7)
        .fill('0')
        .map((_, index) => {
          return <Skeleton key={`${idx}-${index}`} />
        }),
    )
